<template>
  <main class="unbind-list-page">
    <AppNavBar :title="t('card.unBindCardText_17')" background-color="#f7f7f7" />

    <section v-if="!items.length" class="empty-state">
      <AppEmptyState plain />
      <p>{{ t('common.noData') }}</p>
    </section>

    <section v-else class="unbind-list">
      <button
        v-for="item in items"
        :key="item.id"
        type="button"
        class="unbind-list__item"
        @click="openDetail(item)"
      >
        <div>
          <div class="unbind-list__number">{{ t('card.cardNumber') }}{{ item.maskedPan || '--' }}</div>
          <div class="unbind-list__time">{{ item.createTime || '--' }}</div>
        </div>
        <div class="unbind-list__status">
          <span>{{ t('card.unBindCardText_18') }}</span>
          <app-image src="@/assets/images/rightArrow_icon.png" alt="" />
        </div>
      </button>
    </section>
  </main>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { pcCardCancelList } from '@/api/card';
import { navigateWithState } from '@/utils/route-state';

const { t } = useI18n();
const router = useRouter();
const items = ref([]);

const loadList = async () => {
  try {
    const result = await pcCardCancelList();
    items.value = Array.isArray(result) ? result : (result?.list || []);
  } catch (error) {
    items.value = [];
  }
};

const openDetail = (item) => {
  navigateWithState(router, '/card/unbind/detail', {
    namespace: 'card-unbind-detail',
    payload: { id: item.id }
  });
};

onMounted(loadList);
</script>

<style scoped lang="scss">
.unbind-list-page {
  min-height: var(--app-viewport-height);
  background: #f7f7f7;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 160px;
  color: #999999;
  font-size: 16px;

  .app-empty-state__image {
    display: block;
    width: 120px;
    max-width: 100%;
  }

  p {
    margin: 20px 0 0;
  }
}

.unbind-list {
  padding: 15px 14px calc(16px + env(safe-area-inset-bottom));
}

.unbind-list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 78px;
  margin-top: 10px;
  padding: 12px;
  border: 0;
  border-radius: 8px;
  background: #ffffff;
  color: #333333;
  text-align: left;

  &:first-child {
    margin-top: 0;
  }
}

.unbind-list__number {
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}

.unbind-list__time {
  margin-top: 2px;
  color: #999999;
  font-size: 13px;
  line-height: 20px;
}

.unbind-list__status {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;

  span {
    color: #ef0027;
  }

  .app-image {
    width: 9px;
    height: 14px;
    margin-left: 5px;
    object-fit: contain;
  }
}
</style>
